import {
  Typography,
  Button,
  CircularProgress,
  Select,
  ListItemText,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
  TextField,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { DmsManufacturer } from "../../models/features/ShoppingPortal/DmsManufacturer";
import {
  removeDmsManufacturer,
  useAddDmsManufacturerMutation,
  useDeleteDmsManufacturerMutation,
  useGetDMSManufacturersBySettingsIdQuery,
  useUpdateDmsManufacturerDisplayNameMutation,
} from "../../redux/reducer/features/Integration/DmsSetupSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import { Dispatch } from "@reduxjs/toolkit";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import TruncatedCellWithTooltip from "../common/TruncatedCellWithTooltip";
import { ProductManufacturer } from "../../models/features/Product/Product";
import { useGetDmsManufacturersQuery } from "../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { useGetManufacturersQuery } from "../../redux/reducer/features/Product/productSlice";
import { StyledTableCell } from "../common/StyledTableCell";

interface ManufacturerSettingsProps {}
export const ManufacturerSettings: React.FC<ManufacturerSettingsProps> = () => {
  const dispatch = useDispatch<Dispatch<any>>();
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const locations = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.dmsLocations,
  );

  const [removeMappingConfirm, setRemoveMappingConfirm] = useState(false);
  const [selectedDmsMfr, setSelectedDmsMfr] = useState<DmsManufacturer>();
  const [dmsManufacturersBySetup, setDmsManufacturersBySetup] = useState<
    DmsManufacturer[]
  >([]);
  const [openMfrMapping, setOpenMfrMapping] = useState(false);
  const [mfrFilter, setMfrFilter] = useState("all");
  const [isEditMfrMapping, setIsEditMfrMapping] = useState(false);
  const [selectedCatalogMfr, setselectedCatalogMfr] = useState<
    ProductManufacturer | undefined
  >(undefined);
  const [dmsManufacturersByEverest, setDmsManufacturersByEverest] = useState<
    DmsManufacturer[]
  >([]);
  const [mfrPopupFilter, setMfrPopupFilter] = useState("all");
  const [errorMessage, setErrorMessage] = useState("");
  const [manufacturersByCatalog, setManufacturersByCatalog] = useState<
    ProductManufacturer[]
  >([]);
  const [editingRowId, setEditingRowId] = useState<string | null>(null);
  const [editingDisplayName, setEditingDisplayName] = useState("");

  const [deleteDmsMfrMutation, deleteDmsMfrMutationResult] =
    useDeleteDmsManufacturerMutation();
  const { data, refetch } = useGetDMSManufacturersBySettingsIdQuery({
    dealerSettingsId: dmsSetup?.dealerSettings?.id ?? "",
  });
  const { data: dmsManufacturersList } = useGetDmsManufacturersQuery({
    dealerId: locations ? (locations[0].dealerId.toString() ?? "") : "",
  });
  const { data: catalogMfrs } = useGetManufacturersQuery();
  const [addDmsManufacturerMutation, addDmsManufacturerMutationResult] =
    useAddDmsManufacturerMutation();
  const [updateDisplayNameMutation] =
    useUpdateDmsManufacturerDisplayNameMutation();

  useEffect(() => {
    if (catalogMfrs && catalogMfrs.status === 0) {
      setManufacturersByCatalog(catalogMfrs.entityList ?? []);
    }
  }, [catalogMfrs]);
  useEffect(() => {
    if (data && data.status === 200) {
      setDmsManufacturersBySetup(
        (data.entityList ?? []).map((n) => ({
          ...n,
          displayName: n.displayName || n.name,
        })),
      );
    }
  }, [data]);

  useEffect(() => {
    if (
      dmsManufacturersList?.entityList &&
      dmsManufacturersList.entityList?.length > 0
    ) {
      setDmsManufacturersByEverest(dmsManufacturersList.entityList);
    }
  }, [dmsManufacturersList]);

  const handleClose = () => {
    setErrorMessage("");
    setRemoveMappingConfirm(false);
    setOpenMfrMapping(false);
    setselectedCatalogMfr(undefined);
    setSelectedDmsMfr(undefined);
    setIsEditMfrMapping(false);
  };

  const handleChangeCatalogMfr = (value: string) => {
    var newMfr = manufacturersByCatalog.find((c) => c?.id === value);
    setselectedCatalogMfr(newMfr);
  };

  const handleDeleteDmsManufacturer = () => {
    deleteDmsMfrMutation({ mfrId: selectedDmsMfr?.id ?? "" }).then(
      (res: any) => {
        if (res && res.data) {
          let mfrs = dmsManufacturersBySetup.filter(
            (x) => x.id !== selectedDmsMfr?.id,
          );
          setDmsManufacturersBySetup(mfrs);
          dispatch(removeDmsManufacturer({ id: selectedDmsMfr?.id ?? "" }));
          refetch();
          setRemoveMappingConfirm(false);
        }
      },
    );
    setSelectedDmsMfr(undefined);
  };
  const handleOpenAddManufacturer = () => {
    setSelectedDmsMfr(undefined);
    setOpenMfrMapping(true);
  };
  const handleChangeDMSManufacturer = (value: any) => {
    var newMfr = dmsManufacturersByEverest.find(
      (c) => c.manufacturerId === value,
    );
    setSelectedDmsMfr(
      newMfr ? { ...newMfr, displayName: newMfr.name } : undefined,
    );
  };
  const handleAddManufacturer = () => {
    let mfr: any;

    if (locations && locations[0].dmsType === 0) {
      mfr = {
        ...selectedDmsMfr,
        id: isEditMfrMapping ? selectedDmsMfr?.id : undefined,
        catalogManufacturerId: selectedCatalogMfr?.id ?? "",
        isWholegoodManufacturer: true,
        isPartManufacturer: true,
        DealerSettingsId: dmsSetup?.dealerSettings?.id ?? "",
      };
    } else {
      mfr = {
        ...selectedDmsMfr,
        id: isEditMfrMapping ? selectedDmsMfr?.id : undefined,
        catalogManufacturerId: selectedCatalogMfr?.id ?? "",
        isWholegoodManufacturer:
          mfrPopupFilter === "all" || mfrPopupFilter === "wholegood"
            ? true
            : false,
        isPartManufacturer:
          mfrPopupFilter === "all" || mfrPopupFilter === "part" ? true : false,
        DealerSettingsId: dmsSetup?.dealerSettings?.id ?? "",
      };
    }

    addDmsManufacturerMutation({
      request: mfr,
    }).then((res: any) => {
      if (res && res.data) {
        if (res && res.data.status === 200) {
          handleClose();
          refetch();
        }
      }
    });
  };

  return (
    <>
      <Box display="flex" justifyContent="right" mb={1}>
        <Button
          size="small"
          variant="contained"
          onClick={handleOpenAddManufacturer}
          startIcon={<AddIcon />}
          style={{ marginRight: 10 }}
        >
          Add Manufacturer
        </Button>
        <Select
          value={mfrFilter}
          sx={{ width: "110px" }}
          onChange={(e) => setMfrFilter(e.target.value)}
          variant="standard"
        >
          <MenuItem selected value="all">
            All
          </MenuItem>
          <MenuItem value="part">Part</MenuItem>
          <MenuItem value="wholegood">Wholegood</MenuItem>
        </Select>
      </Box>
      <TableContainer sx={{ maxHeight: "45vh" }} component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ fontWeight: "bold" }}>
                DMS Mfr Code
              </StyledTableCell>
              <StyledTableCell sx={{ fontWeight: "bold" }}>
                DMS Mfr Name
              </StyledTableCell>
              <StyledTableCell sx={{ fontWeight: "bold" }}>
                Mfr Display Name
              </StyledTableCell>
              <StyledTableCell sx={{ fontWeight: "bold" }}>
                Type
              </StyledTableCell>
              <StyledTableCell sx={{ fontWeight: "bold" }}>
                Catalog Mfr Name
              </StyledTableCell>

              <StyledTableCell align="center" sx={{ fontWeight: "bold" }}>
                Status
              </StyledTableCell>
              <StyledTableCell sx={{ fontWeight: "bold" }} align="center">
                Actions
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dmsManufacturersBySetup.length > 0 ? (
              dmsManufacturersBySetup
                .filter((n) => {
                  if (mfrFilter === "all") return true;
                  if (mfrFilter === "wholegood" && n.isWholegoodManufacturer)
                    return true;
                  if (mfrFilter === "part" && n.isPartManufacturer) return true;
                  return false;
                })
                .map((row, index) => (
                  <TableRow key={index}>
                    <StyledTableCell sx={{ padding: 1.5 }}>
                      {row.code}
                    </StyledTableCell>
                    <StyledTableCell sx={{ padding: 1.5 }}>
                      {<TruncatedCellWithTooltip value={row.name} />}
                    </StyledTableCell>
                    <StyledTableCell sx={{ padding: 1.5 }}>
                      {editingRowId === row.manufacturerId ? (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <TextField
                            size="small"
                            variant="standard"
                            value={editingDisplayName}
                            onChange={(e) =>
                              setEditingDisplayName(e.target.value)
                            }
                            autoFocus
                            fullWidth
                            sx={{ mr: 0.5 }}
                          />
                          <IconButton
                            size="small"
                            color="success"
                            onClick={() => {
                              if (editingDisplayName !== row.displayName) {
                                updateDisplayNameMutation({
                                  manufacturer: {
                                    ...row,
                                    displayName: editingDisplayName,
                                    dealerSettingsId:
                                      dmsSetup?.dealerSettings?.id ?? "",
                                  },
                                }).then((res: any) => {
                                  if (res?.data) {
                                    refetch();
                                  }
                                });
                                setDmsManufacturersBySetup((prev) =>
                                  prev.map((n) =>
                                    n.manufacturerId === row.manufacturerId
                                      ? {
                                          ...n,
                                          displayName: editingDisplayName,
                                        }
                                      : n,
                                  ),
                                );
                              }
                              setEditingRowId(null);
                            }}
                          >
                            <CheckIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => setEditingRowId(null)}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ) : (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <TruncatedCellWithTooltip value={row.displayName} />
                          <IconButton
                            size="small"
                            onClick={() => {
                              setEditingRowId(row.manufacturerId);
                              setEditingDisplayName(row.displayName || "");
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      )}
                    </StyledTableCell>
                    <StyledTableCell sx={{ padding: 1.5 }}>
                      {row.isPartManufacturer && (
                        <Chip label="Part" size="small" />
                      )}
                      {row.isWholegoodManufacturer && (
                        <Chip label="Wholegood" size="small" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell sx={{ padding: 1.5 }}>
                      {
                        <TruncatedCellWithTooltip
                          value={row?.catalogManufacturer?.title}
                        />
                      }
                    </StyledTableCell>
                    <StyledTableCell sx={{ padding: 1.5 }} align="center">
                      {row.catalogManufacturerId ? (
                        <Chip
                          size="small"
                          color="success"
                          label="Mapped"
                        ></Chip>
                      ) : (
                        <Chip
                          size="small"
                          color="error"
                          label="Not Mapped"
                        ></Chip>
                      )}
                    </StyledTableCell>
                    <StyledTableCell sx={{ padding: 0.5 }} align="center">
                      <IconButton
                        id="basic-button"
                        onClick={(n) => {
                          setSelectedDmsMfr(row);
                          setIsEditMfrMapping(true);
                          setOpenMfrMapping(true);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>{" "}
                      |{" "}
                      <IconButton
                        id="basic-button"
                        onClick={(n) => {
                          setSelectedDmsMfr(row);
                          setRemoveMappingConfirm(true);
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </StyledTableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <StyledTableCell align="center" colSpan={7}>
                  No Rows to Show
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={removeMappingConfirm} onClose={handleClose} fullWidth>
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          Confirm to Delete
        </DialogTitle>
        <DialogContent>
          Are you sure to delete this manufacturer mapping?
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            autoFocus
            onClick={() => {
              setRemoveMappingConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            disabled={deleteDmsMfrMutationResult.isLoading}
            endIcon={
              deleteDmsMfrMutationResult.isLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <></>
              )
            }
            onClick={() => {
              handleDeleteDmsManufacturer();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openMfrMapping} onClose={handleClose} fullWidth>
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          {isEditMfrMapping ? "Edit Manufacturer" : "Add Manufacturer"}
        </DialogTitle>
        <DialogContent sx={{ minHeight: "15vh" }}>
          <Typography fontSize="15px">
            {isEditMfrMapping
              ? "Select a catalog manufacturer to Edit mapping."
              : "Select a DMS manufacturer and a catalog manufacturer to map them."}
          </Typography>
          {locations && locations[0].dmsType !== 0 && (
            <FormControl fullWidth sx={{ mt: 3 }}>
              <InputLabel id="manufacturerType">
                DMS Manufacturer Type
              </InputLabel>
              <Select
                value={mfrPopupFilter}
                fullWidth
                labelId="manufacturerType"
                size="small"
                id="manufacturerType"
                label="DMS Manufacturer Type"
                onChange={(e) => setMfrPopupFilter(e.target.value)}
              >
                <MenuItem selected value="all">
                  All
                </MenuItem>
                <MenuItem value="part">Part</MenuItem>
                <MenuItem value="wholegood">Wholegood</MenuItem>
              </Select>
            </FormControl>
          )}
          <Box display={isEditMfrMapping ? "none" : "block"}>
            <FormControl variant="outlined" fullWidth sx={{ mt: 3 }}>
              <InputLabel id="manufacturer">DMS Manufacturer</InputLabel>
              <Select
                labelId="manufacturer"
                id="manufacturerId"
                size="small"
                label="DMS Manufacturer"
                fullWidth
                value={selectedDmsMfr?.manufacturerId ?? 0}
                onChange={(e) => handleChangeDMSManufacturer(e.target.value)}
              >
                {dmsManufacturersByEverest
                  .filter((n) => {
                    if (mfrPopupFilter === "all") return true;
                    if (
                      mfrPopupFilter === "wholegood" &&
                      n.isWholegoodManufacturer
                    )
                      return true;
                    if (mfrPopupFilter === "part" && n.isPartManufacturer)
                      return true;
                    return false;
                  })
                  .filter(
                    (x) =>
                      !dmsManufacturersBySetup.some(
                        (y) => y.manufacturerId === x.manufacturerId,
                      ) && x.isActive,
                  )
                  .map((col) => (
                    <MenuItem
                      key={col.manufacturerId}
                      value={col.manufacturerId}
                    >
                      <ListItemText
                        primary={
                          col.code +
                          " - " +
                          col.name +
                          " (" +
                          col.commonMfgId +
                          ")"
                        }
                      />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          <FormControl variant="outlined" fullWidth sx={{ mt: 3 }}>
            <InputLabel id="catalog-mfr">Catalog Manufacturer</InputLabel>
            <Select
              labelId="catalog-mfr"
              id="catalogMfr"
              size="small"
              label="Catalog Manufacturer"
              fullWidth
              value={selectedCatalogMfr?.id ?? "0"}
              onChange={(e) => handleChangeCatalogMfr(e.target.value)}
            >
              {manufacturersByCatalog.map((col) => (
                <MenuItem key={col.id} value={col.id}>
                  <ListItemText
                    primary={
                      col?.shortTitle +
                      " - " +
                      col?.title +
                      (col?.commonMfgId ? " (" + col?.commonMfgId + ")" : "")
                    }
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            size="small"
            label="MFR Display Name"
            required
            value={selectedDmsMfr?.displayName ?? ""}
            onChange={(e) =>
              setSelectedDmsMfr((prev) =>
                prev ? { ...prev, displayName: e.target.value } : prev,
              )
            }
            sx={{ mt: 3 }}
          />

          <Typography mt={3} color="error">
            {errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={
              !selectedCatalogMfr ||
              !selectedDmsMfr ||
              !(selectedDmsMfr?.displayName ?? "").trim() ||
              addDmsManufacturerMutationResult.isLoading
            }
            endIcon={
              addDmsManufacturerMutationResult.isLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <></>
              )
            }
            onClick={() => {
              if (selectedDmsMfr && selectedCatalogMfr) handleAddManufacturer();
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
